import { motion } from 'framer-motion'

const Divider = () => {
  const liVariant = {
    opened: {
      opacity: 1,
      y: '0%',
      transition: { duration: 0.65, ease: 'easeOut' },
    },
    closed: {
      opacity: 0,
      y: '100%',
      transition: { duration: 0.25, ease: 'easeInOut' },
    },
  }
  return (
    <motion.div
      variants={liVariant}
      className='w-full border-t border-gray border-dashed my-[30px]'
    />
  )
}

export default Divider
